import { createSelector } from "@reduxjs/toolkit";
import { ImageCustomMetadata } from "types";
import { State } from "redux/store";

const state = (state: State) => state.singleImage;

export const getSelectedObjectLabels = createSelector(state, (state) => {
  return state.selectedObjectLabels;
});

export const getImageCustomMetadata = createSelector(
  state,
  (state): ImageCustomMetadata[] => {
    return state.imageCustomMetadata;
  },
);
